import React from "react";
import { cn } from "@/util/functions";
import { Button as HeadlessButton } from "@headlessui/react";

const sizeClasses = {
  small: "tw-px-2 tw-py-1 tw-text-xs",
  medium: "tw-px-4 tw-py-2 tw-text-sm",
  large: "tw-px-6 tw-py-3 tw-text-lg",
};

const variantClasses = {
  rect: "tw-rounded-md",
  circle: "tw-rounded-full",
};

const Button = ({
  children,
  className = "",
  icon: Icon,
  size = "medium",
  shape = "rect",
  ...props
}) => {
  return (
    <HeadlessButton
      {...props}
      className={cn(
        "tw-inline-flex tw-gap-1 tw-items-center tw-border tw-border-transparent tw-font-medium tw-rounded-full tw-shadow-md tw-bg-white hover:tw-bg-gray-100 focus:tw-bg-gray-200 focus:tw-shadow-lg focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-gray-500",
        sizeClasses[size],
        variantClasses[shape],
        className
      )}
    >
      {Icon}
      {children}
    </HeadlessButton>
  );
};

export default Button;
